import { $getRoot, $isElementNode, type LexicalNode } from 'lexical'
import { $getEmailNode } from '../nodes/EmailNode'
import { $isGroupNode } from '../nodes/GroupNode'
import { $isLockedBlockNode } from '../nodes/LockedBlockNode'
import { $isSlotNode, type SlotNode } from '../nodes/SlotNode'
import { type LexNode } from './validateState'

const $toJson = (node: LexicalNode): LexNode => {
  const json = node.exportJSON() as unknown as LexNode
  return $isElementNode(node) ? { ...json, children: node.getChildren().map($toJson) } : json
}

const contentSignature = (nodes: LexNode[]): unknown =>
  nodes.map((node) => {
    if (node.type === 'variable') {
      return ['variable', node.variable, node.format ?? 0]
    }
    if (node.type === 'text') {
      return ['text', node.text, node.format ?? 0]
    }
    return [node.type, node.tag ?? node.listType ?? node.url ?? null, contentSignature(node.children ?? [])]
  })

const $slotContentSignature = (slot: SlotNode): unknown => contentSignature(slot.getChildren().map($toJson))

const $describe = (node: LexicalNode): unknown => {
  if ($isSlotNode(node)) {
    return ['slot', node.getAttrs(), node.isEditable() ? null : $slotContentSignature(node)]
  }
  if ($isLockedBlockNode(node)) {
    return ['locked', node.getBlockId(), node.getLabel(), node.getHtml(), node.getBadges()]
  }
  if ($isGroupNode(node)) {
    return ['group', node.getGroupId(), node.getWrapper(), node.getBadges(), node.getChildren().map($describe)]
  }
  return ['other', node.getType()]
}

export const $structure = (): string => {
  const email = $getEmailNode()
  if (!email || $getRoot().getChildrenSize() !== 1) {
    return 'invalid'
  }
  return JSON.stringify([email.getFrame(), email.getVariables(), email.getTextStyles(), email.getChildren().map($describe)])
}
